import { err, ok, Result } from 'neverthrow'
import { ExpertsClient } from './axios-clients/experts.client'
import { AxiosError } from 'axios'
import {
    AttemptHistoryResponseType,
    CreateAttemptResponseType,
    ExamDetailResponseType,
    ExamListResponseType,
    GetExamAssignmentResponseType,
    GetAttemptResponseType,
    SubmitAttemptResponseType,
    GetQuestionPreviewResponseType,
    GetQuestionFeedbackResponseType,
} from 'Types/Exams.types'

export const getExamsByUserIdApi = async (
    userId: string
): Promise<Result<ExamListResponseType, AxiosError>> => {
    try {
        const payload = { user_id: userId }

        const resp = await ExpertsClient.post<ExamListResponseType>(
            '/v1/exams/get-attemptable-exams-for-user ',
            payload
        )
        return ok(resp.data)
    } catch (e) {
        return err(e as AxiosError)
    }
}

export const getExamDetailForCandidateApi = async (
    userId: string,
    examId: string
): Promise<Result<ExamDetailResponseType, AxiosError>> => {
    try {
        const payload = { exam_id: examId, user_id: userId }
        const resp = await ExpertsClient.post<ExamDetailResponseType>(
            '/v1/exams/get-detail-for-candidate',
            payload
        )
        return ok(resp.data)
    } catch (e) {
        return err(e as AxiosError)
    }
}

export const getAttemptHistoryByUserIdApi = async (
    userId: string
): Promise<Result<AttemptHistoryResponseType, AxiosError>> => {
    try {
        const payload = { user_id: userId }
        const resp = await ExpertsClient.post<AttemptHistoryResponseType>(
            `/v1/attempts/get-attempts-by-user-id`,
            payload
        )
        return ok(resp.data)
    } catch (e) {
        return err(e as AxiosError)
    }
}

export const createAttemptApi = async (
    userId: string,
    examId: string
): Promise<Result<CreateAttemptResponseType, AxiosError>> => {
    try {
        const payload = { exam_id: examId, user_id: userId }
        const resp = await ExpertsClient.post<CreateAttemptResponseType>(
            '/v1/attempts/create-attempt',
            payload
        )
        return ok(resp.data)
    } catch (e) {
        return err(e as AxiosError)
    }
}

export const getAttemptApi = async (
    attemptId: string
): Promise<Result<GetAttemptResponseType, AxiosError>> => {
    try {
        const resp = await ExpertsClient.get<GetAttemptResponseType>(
            `/v1/attempts/${attemptId}/get-detail-for-candidate`
        )
        return ok(resp.data)
    } catch (e) {
        return err(e as AxiosError)
    }
}

export const submitAttemptApi = async (
    attemptId: string
): Promise<Result<SubmitAttemptResponseType, AxiosError>> => {
    try {
        const resp = await ExpertsClient.post<SubmitAttemptResponseType>(
            `/v1/attempts/${attemptId}/submit`
        )
        return ok(resp.data)
    } catch (e) {
        return err(e as AxiosError)
    }
}

export const getExamAssignmentApi = async (
    answerId: string,
    userId: string
): Promise<Result<GetExamAssignmentResponseType, AxiosError>> => {
    try {
        const payload = { answer_id: answerId, user_id: userId }
        const resp = await ExpertsClient.post<GetExamAssignmentResponseType>(
            `/v1/expert-view/get-assignment-for-answer`,
            payload
        )
        return ok(resp.data)
    } catch (e) {
        return err(e as AxiosError)
    }
}

export const getQuestionPreviewApi = async ({
    questionVersionId,
    examVersionId,
    questionsetVersionId,
}: {
    questionVersionId: string
    examVersionId: string
    questionsetVersionId: string
}): Promise<Result<GetQuestionPreviewResponseType, AxiosError>> => {
    try {
        const payload = {
            question_version_id: questionVersionId,
            exam_version_id: examVersionId,
            questionset_version_id: questionsetVersionId,
        }
        const resp = await ExpertsClient.post<GetQuestionPreviewResponseType>(
            `v1/internal-view/questions-management/preview-question-as-task`,
            payload
        )
        return ok(resp.data)
    } catch (e) {
        return err(e as AxiosError)
    }
}

export const getAttributeFeedbackApi = async (
    answerId: string
): Promise<Result<GetQuestionFeedbackResponseType, AxiosError>> => {
    try {
        const resp = await ExpertsClient.get<GetQuestionFeedbackResponseType>(
            `/v1/answers/${answerId}/get-evaluation-feedback`
        )
        return ok(resp.data)
    } catch (e) {
        return err(e as AxiosError)
    }
}
